import api from './client';
import type {
  PricesResponse,
  SubscriptionResponse,
  CreateCheckoutResponse,
  CreatePortalResponse,
} from '@/types/database';

interface Envelope<T> {
  success: boolean;
  data: T;
}

export async function getPrices(): Promise<PricesResponse> {
  const res = await api.get<Envelope<PricesResponse>>('/api/subscription/prices');
  return res.data;
}

export async function getSubscription(): Promise<SubscriptionResponse> {
  const res = await api.get<Envelope<SubscriptionResponse>>('/api/subscription');
  return res.data;
}

export async function createCheckout(params: {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
  onboardingOffer?: boolean;
}): Promise<CreateCheckoutResponse> {
  const res = await api.post<Envelope<CreateCheckoutResponse>>(
    '/api/subscription/create-checkout',
    {
      price_id: params.priceId,
      success_url: params.successUrl,
      cancel_url: params.cancelUrl,
      ...(params.onboardingOffer ? { onboarding_offer: true } : {}),
    }
  );
  return res.data;
}

export async function createPortal(returnUrl: string): Promise<CreatePortalResponse> {
  const res = await api.post<Envelope<CreatePortalResponse>>(
    '/api/subscription/create-portal',
    { return_url: returnUrl }
  );
  return res.data;
}
